<template lang="pug">
.content-wrapper(v-if='currentUser.rights.browseClients == true')
  .table-header.d-flex.pb-2.justify-content-between
    h2.m-0 Клиенты
    button(v-bind:class="['btn', 'btn-info', 'border-0', 'col-2', {'d-none': currentUser.rights.editClients == false}]" v-on:click='createClient') Добавить клиента
  .clients-table
    table.table.table-hover
      thead
        tr
          th(v-for='h in columnsHeader' v-bind:key='h.key' v-on:click='sortBy(h.key)' v-bind:class='{ active: sortKey == h.key }')
            | {{ h.title }}
            span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc', {'d-none': h.key =='actions'}]")
      tbody
        tr(v-for='(row, index) in filteredClients' v-bind:key='row.id')
          td(v-for='td in columnsHeader' v-bind:key='td.id')
            | {{ row[td.key] }}
            span(v-if="td.key === 'actions'" v-bind:class="['td-actions', {'d-none': currentUser.rights.editClients == false}]")
              a(href='#' v-bind:class="{'d-none': currentUser.rights.canSubLogin == false}")
                i.fas.fa-user
              span(v-bind:class="{'d-none': currentUser.rights.editClients == false}")
                i.fas.fa-pen(v-on:click='editClient(index)')
                a(href='#')
                  i.fas.fa-envelope
                i.fas.fa-trash(v-on:click='removeItem(index, row.id)')
  modal(v-show='isModalVisible' v-on:close='closeModal')
    template(v-slot:header='')
      h2(v-if='!!formData.id') Редактирование
      h2(v-else='') Новый клиент
    template(v-slot:body='')
      form#ClientsForm(v-on:submit.prevent='formSubmit')
        .form-group.col-12
          label(for='inputName') Клиент
          input#inputName.form-control(type='text' placeholder='Введите данные' v-model='formData.name' required='')
        .form-group.col-12
          label(for='inputEmail') Email
          input#inputEmail.form-control(v-model='formData.email' type='email' placeholder='Введите email' required='')
        .form-group.col-12
          label(for='inputTel') Телефон
          input#inputTel.form-control(v-model='formData.phone' type='tel' placeholder='Введите телефон' required='')
        .form-group.d-flex.justify-content-between.col-12.flex-wrap
          label.col-12(for='InputPassword') Пароль
          input#InputPassword.form-control.col-6(v-model='formData.password' type='text' placeholder='Введите пароль' required='')
          span.btn.btn-info.col-3(v-on:click='getPassword') Генерация пароля
    template(v-slot:footer='')
      .form-group.d-flex.justify-content-between.col-12
        button(v-bind:class="['btn', 'btn-info', 'col-2', {'d-none': currentUser.rights.editClients == false}]" type='submit' form='ClientsForm') &Scy;&ocy;&khcy;&rcy;&acy;&ncy;&icy;&tcy;&softcy;
        button.btn.btn-secondary.col-2(type='submit' v-on:click='closeModal') Отмена
.alert.alert-warning.alert-dismissible.fade.show(v-else='' role='alert')
  strong Holy guacamole!
  |  You should check your rights.
  button.close(type='button' data-dismiss='alert' aria-label='Close')
    span(aria-hidden='true') &times;
</template>
<script>
export default {
  data: function () {
    var columnsHeader = [
      {title: 'Клиент', key: 'name'},
      {title: 'Телефон', key: 'phone'},
      {title: 'Email', key: 'email'},
      {title: 'Дата регистрации', key: 'reg_date'},
      {title: 'Действия ', key: 'actions'}
    ]
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      isModalVisible: false,
      deleteClientIndex: 0,
      formData: {
        id: '',
        name: '',
        email: '',
        phone: '',
        reg_date: '',
        password: ''
      },
      // отправить собранные данные на сервер
      sortKey: '',
      sortOrders: sortOrders,
      searchQuery: '',
      selectFilters: [],
      columnsHeader: columnsHeader,
      clients: null
    }
  },
  methods: {
    sortBy: function (key) {
      // console.log(key)
      this.sortKey = key
      this.sortOrders[key] *= -1
      // console.log(this.sortOrders[key])
      // console.log('sortKey debug');
      // console.log(key);
      // console.log(this.sortOrders[key] );
      // console.log(this.sortOrders );
    },
    getPassword () {
      var password = ''
      var symbols = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      var length = 8
      for (var i = 0; i < length; i++) {
        password += symbols.charAt(Math.floor(Math.random() * symbols.length))
      }
      this.formData.password = password
    },
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    },
    createClient () {
      this.refreshFormData()
      this.showModal()
    },
    saveClient (response) {
      var client = {}
      client = response.data.client
      if (this.formData.id === 0) {
        this.clients.unshift(client)
      } else {
        var index = this.clients.map(function (el) { console.log(el); return el.id * 1 }).indexOf(client.id)
        var keys = Object.keys(client)
        for (var ind in keys) {
          var key = keys[ind]
          this.clients[index][key] = client[key]
        }
      }
    },
    deleteClient (response) {
      var data = response.data
      if (!data.error) {
        this.clients.splice(this.deleteClientIndex, 1)
      } else {
        alert('Ошибка удаления клиента ' + data.error_description)
      }
    },
    formSubmit (event) {
      var p = this.formData
      p.action = 'saveClient'
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        .then(this.saveClient)
      this.closeModal()
    },
    refreshFormData () {
      this.formData = {id: 0, name: '', email: '', phone: '', reg_date: '', password: ''}
    },
    editClient (index) {
      this.formData = JSON.parse(JSON.stringify(this.clients[index]))
      this.showModal()
    },
    removeItem (index, id) {
      var result = confirm('Подтвердите удаление клиента')
      if (result) {
        var p = {
          action: 'deleteClient',
          id: id
        }
        this.deleteClientIndex = index
        this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
          .then(this.deleteClient)
      }
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    filteredClients: function () {
      var sortKey = this.sortKey
      // var filterKey = this.searchQuery && this.searchQuery.toLowerCase()
      var clients = this.clients
      // var selectFilters = this.selectFilters
      // console.log(filterKey);
      // add more vars to filter
      var order = this.sortOrders[sortKey] || 1
      // if (filterKey || (this.selectFilters != '')) {
      //     calls  = this.callsList.filter(function (row) {
      //         return Object.keys(row).some(function (key) {
      //             // console.log(row);
      //             // if (row['tariff_id'] < 1) {
      //             //     return false;
      //             // }
      //             // console.log(demo._data.selectFilters);
      //
      //             if(selectFilters == 'not_connected'){
      //                 // console.log(123);
      //                 if (row['tariff_id'] > 0) {
      //                     return false;
      //                 }
      //             }
      //             if(selectFilters == 'connected'){
      //                 if (!row['active']) {
      //                     return false;
      //                 }
      //
      //             }
      //             if(selectFilters == 'blocked') {
      //                 if (row['active'] || row['tariff_id'] < 1) {
      //                     return false;
      //                 }
      //             }
      //             if(selectFilters == 'archived'){
      //                 if (!row['is_archive:']) {
      //                     return false;
      //                 }
      //             }
      //
      //             return String(row[key]).toLowerCase().indexOf(filterKey) > -1
      //         })
      //     })
      //   }
      // console.log(sortKey)
      if (sortKey) {
        // console.log(heroes)
        clients = clients.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          // console.log(a)
          // console.log(b)
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return clients
      // console.log(heroes)
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser () {
      return this.$store.getters.user
    }
  },
  mounted () {
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getClientsList')
      .then(response => (this.clients = response.data.clients))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/clients.vue